export default __webpack_public_path__ + "static/Metal_Doorframe-af133697a84a00092ddab466ba1b5537.png";